module.exports = __webpack_public_path__ + "media/assets/images/landings/iot/screens/events_chart-21d2d8dd289c7a05677204a694887d6f.png";